import React from 'react'
import { GlobalContextProviders } from '@/components/globalContextProviders'
import Resx from '@/components/Resx'
import { preventAndStop } from '../core/utils'

class RowEditorRendererBase extends React.Component {
  getOrder () {
    const userRowOrderArray = this.props.parent.children.filter(x => x.isUserRow).map(x => x.order)
    let maxOrder = 0

    if (userRowOrderArray.length) {
      maxOrder = Math.max(...userRowOrderArray)
    }

    return maxOrder + 1
  }

  createRow (name, latinName) {
    throw Error('Method must be overridden')
  }

  handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.onClick()
  }

  onClick () {
    throw Error('Method must be overridden')
  }

  render () {
    return <GlobalContextProviders>
      <div>
        <button onMouseDown={preventAndStop} onClick={this.handleClick}><i className='bx bx-plus' /><Resx name='Common.Add' /></button>
      </div>
    </GlobalContextProviders>
  }
}

export { RowEditorRendererBase }



// WEBPACK FOOTER //
// ./src/components/report-tables/headers/rowEditorRendererBase.js